module.exports = __webpack_public_path__ + "img/crisis_population_displacement_100px_bluebox.37cf0733.png";